<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <v-select
                v-model="currentObject"
                :options="tags"
                :loading="isLoading || booting"
                label="name"
                ref="selector"
        >
        </v-select>
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';
    import vSelect from 'vue-select';

    export default {
        name: "TagSelect",
        components: {
            vSelect
        },
        mixins: [
            fieldInfo,
        ],
        data: function () {
            return {
                booting: true,
                currentObject: null
            }
        },
        computed: {
            tags() {
                return this.$store.state.composer.tags;
            },
            isLoading() {
                return this.$store.getters.isLoading('tags');
            }
        },
        methods: {
            setObject(tag) {
                this.currentValue = tag ? tag.id : null;
                this.booting = false;
            }
        },
        watch: {
            currentObject(newValue, oldValue) {
                if (newValue !== oldValue && newValue !== undefined && newValue !== '') {
                    this.setObject(newValue);
                }
            }
        },
        created() {
            this.$store.dispatch('boot', 'getTags').then(() => {
                this.booting = false;
                this.currentObject = this.value;
            });
        }
    }
</script>

<style scoped>

</style>